<div class="p-grid">
	<ng-container *ngTemplateOutlet="note && editingNote ? editor : null; context: { $implicit: note }"></ng-container>
	<div *ngIf="!editingNote && entityPager" class="p-col-12 pager-container">
		<div>
			<lb-entity-pager *ngIf="entityPager" [src]="$any(entityPager)" (backToListClicked)="backToList()"></lb-entity-pager>
		</div>
	</div>
	<div class="p-col-12" *ngIf="note && !editingNote && !loadingNote && (!entityPager || (!entityPager.isLoading && !entityPager.hasNoList))">
		<div *ngIf="note.draft && !editingNote" class="p-col-12 p-text-center p-order-0">
			<p-message text="This note is a draft and has not been published for viewing on the log" severity="info"></p-message>
			<p-divider></p-divider>
		</div>

		<!-- MOBILE VIEW -->
		<div class="p-grid p-d-lg-none">
			<div class="p-col-12">
				<ng-container *ngTemplateOutlet="properties; context: { $implicit: note }"></ng-container>
			</div>
			<div class="p-col-12">
				<ng-container *ngTemplateOutlet="noteRender; context: { $implicit: note }"></ng-container>
			</div>
			<div class="p-col-12">
				<ng-container *ngTemplateOutlet="attachments; context: { $implicit: nonRichTextAttachments }"></ng-container>
			</div>
			<div class="p-col-12 detail-container">
				<ng-container *ngTemplateOutlet="details; context: { $implicit: note }"></ng-container>
			</div>
		</div>

		<!-- DESKTOP VIEW -->
		<div class="p-grid p-d-none p-d-lg-flex">
			<div class="p-col-8">
				<ng-container *ngTemplateOutlet="noteRender; context: { $implicit: note }"></ng-container>
				<ng-container *ngTemplateOutlet="details; context: { $implicit: note } "></ng-container>
			</div>
			
			<div class="p-col-4">
				<ng-container *ngTemplateOutlet="properties; context: { $implicit: note }"></ng-container>
				<ng-container *ngTemplateOutlet="attachments; context: { $implicit: nonRichTextAttachments }"></ng-container>
			</div>
		</div>
	</div>
	<div *ngIf="loadingNote || entityPager?.isLoading" class="p-col-12 p-d-flex p-jc-center p-ai-center">
		<lb-loading-indicator label="Loading Note"></lb-loading-indicator>
	</div>
</div>

<ng-template #editor let-note>
	<div class="p-col-12 note-entry-col">
		<ng-container (container)="noteEditorContainerReady($event)"></ng-container>
	</div>
</ng-template>

<ng-template #noteRender>
	<div class="p-grid">
		<div class="p-col-12 p-lg-3 lg-text-right">
			<label class="p-d-none p-d-lg-block p-mb-0">Note</label>
			<div *ngIf="canEditNote">
				<div class="p-d-none p-d-lg-block">
					<a (click)="$event.preventDefault(); startEditingNote()">
						Edit
					</a>
				</div>
			</div>
		</div>

		<div class="p-col-12 p-lg-9">
			<lb-note [noteEdit]="false" [note]="note!" viewStyle="CARD" applyStyles="tagsOnly">
				<ng-template>
					<button *ngIf="canEditNote && !normalWindowMediaQuery.matches"
							pButton class="p-button-info p-button-outlined w-100" label="Edit Note"
							(click)="startEditingNote()">
					</button>
				</ng-template>
			</lb-note>
		</div>
	</div>
</ng-template>

<ng-template #attachments let-attachments>
	<div class="p-grid">
		<div class="p-col-12">
			<label class="p-d-block">Attachments</label>
			<lb-file-attachment-list *ngIf="attachments.length" [fileAttachments]="attachments"></lb-file-attachment-list>
			<span *ngIf="!attachments.length">
				No Attachments
			</span>
		</div>
	</div>
</ng-template>

<ng-template #properties let-note>
	<div class="p-grid">
		<div class="p-col-12">
			<label class="p-d-block">
				Note Time
			</label>
			{{note.noteTime | date: 'MM/dd/yyyy HH:mm:ss'}}
		</div>
		<div class="p-col-6">
			<label class="p-d-block">
				<span class="fa fa-clock-o fa-lg"></span>
				Carry Forward
			</label>
			<span *ngIf="note.carryForward">
				Enabled {{note.carryForwardEndTime ? 'until ' + (note.carryForwardEndTime | date: 'MM/dd/yyyy HH:mm:ss') : 'Indefinitely'}}
			</span>
			<span *ngIf="!note.carryForward">
				Disabled
			</span>
		</div>
		<div class="p-col-6">
			<label class="p-d-block">
				<span class="turnover-icon fa-lg"></span>
				Turnover
			</label>
			{{note.turnover ? 'Enabled' : 'Disabled'}}
		</div>
		<div class="p-col-12">
			<label class="p-d-block">Tags</label>
			<p-chips *ngIf="note.tagValues.length" class="tag-list" [(ngModel)]="note.tagValues" [disabled]="true" placeholder="No Tags">
				<ng-template pTemplate="item" let-tagValue>
					{{tagValue.viewString}}
				</ng-template>
			</p-chips>
			<span *ngIf="!note.tagValues.length">
				No Tags
			</span>
		</div>
	</div>
</ng-template>

<ng-template #details let-note>
	<div *ngIf="!note.draft" class="p-grid">
		<label class="p-col-12 p-lg-3 lg-text-right">
			Comments
		</label>
		<div class="p-col-12 p-lg-9">
			<lb-comment-list (commentsModified)="refreshNote(false)" [commentEntity]="note"></lb-comment-list>
		</div>
	</div>

	<div *ngIf="note.hasSignoffData && !note.draft" class="p-grid">
		<label class="p-col-12 p-lg-3 lg-text-right">
			Signoffs
		</label>
		<div class="p-col-12 p-lg-9">
			<signoff-controls [note]="$any(note)" (refreshed)="refreshNote()"></signoff-controls>
		</div>
	</div>

	<div *ngIf="!note.draft" class="p-grid">
		<label class="p-col-12 p-lg-3 lg-text-right">
			Acknowledgements
		</label>
		<div class="p-col-12 p-lg-9">
			<note-acknowledgements [showAll]="true" [displayShowAllButton]="false" [showTime]="true" [note]="note"></note-acknowledgements>
		</div>
	</div>

	<div class="p-grid">
		<label class="p-col-12 p-lg-3 lg-text-right">
			Updated
		</label>
		<div class="p-col-12 p-lg-9">
			{{note.updated | date: 'MM/dd/yyyy HH:mm'}} by {{note.updatedBy.firstName}} {{note.updatedBy.lastName}}
		</div>
	</div>

	<div class="p-grid">
		<label class="p-col-12 p-lg-3 lg-text-right">
			Created
		</label>
		<div class="p-col-12 p-lg-9">
			{{note.created | date: 'MM/dd/yyyy HH:mm'}} by {{note.createdBy.firstName}} {{note.createdBy.lastName}}
		</div>
	</div>

	<div class="p-grid">
		<label class="p-col-12 p-lg-3 lg-text-right">
			History
		</label>
		<div class="p-col-12 p-lg-9">
			<a href="/#/log-audit?note={{note.id}}&log={{note.logId}}">View Audit Trail</a>
		</div>
	</div>

	<div *ngIf="noteDeleteEnabled" class="p-grid">
		<label class="p-col-12 p-lg-3 lg-text-right">
			Delete
		</label>
		<div class="p-col-12 p-lg-9">
			<button pButton class="p-button-danger" label="Delete" (click)="showDeleteDialog()"></button>
			<p-confirmDialog key="confirm-note-delete-dialog"
							 header="Delete Note"
							 message="Are you sure you want to delete this note?  This cannot be undone!"
							 acceptLabel="Confirm"
							 rejectLabel="Cancel"
							 acceptButtonStyleClass="p-button-danger"
							 rejectButtonStyleClass="p-button-secondary"
							 defaultFocus="reject"
							 icon="pi pi-exclamation-triangle">
			</p-confirmDialog>
		</div>
	</div>

	<div class="p-grid">
		<label class="p-col-12 p-lg-3 lg-text-right">
			Download
		</label>
		<div class="p-col-12 p-lg-9">
			<a href (click)="$event.preventDefault(); showExportDialog = true">
				<span class="fa fa-file-pdf-o"> </span>
				Download as PDF
			</a>
		</div>
	</div>

	<div *ngIf="noteMetadata?.hasLocationInformation" class="p-grid">
		<label class="p-col-12 p-lg-3 lg-text-right">
			Location
		</label>
		<div class="p-col-12 p-lg-9">
			<lb-note-location-map [locationData]="noteMetadata!.locationData!" [templateId]="note.templateId!"></lb-note-location-map>
		</div>
	</div>

	<div *ngIf="noteMetadata?.deviceInfo?.length" class="p-grid">
		<label class="p-col-12 p-lg-3 lg-text-right">
			Device
		</label>
		<div class="p-col-12 p-lg-9">
			<a (click)="$event.preventDefault(); showDeviceInfo = !showDeviceInfo">
				{{showDeviceInfo ? 'Hide' : 'Show'}} Device Details
			</a>
			<p-table *ngIf="showDeviceInfo" [value]="noteMetadata!.deviceInfo!">
				<ng-template pTemplate="body" let-data>
					<tr>
						<td>{{data.keyDescription}}</td>
						<td>{{data.stringValue}}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</ng-template>

<lb-export-dialog [(showExportDialog)]="showExportDialog" (exportToPDFClicked)="onExportToPdfClicked($event)">
</lb-export-dialog>